export const selectData = (state) => state.mapData.data;
export const selectFilter = (state) => state.mapData.filter;
export const selectMode = (state) => state.mapData.mode;
export const selectStatus = (state) => state.mapData.status;
export const selectSliderValue = (state) => state.mapData.sliderValue;
export const selectBbox = (state) => state.mapData.bbox;